import React, { useState, useEffect } from "react"
import { Link } from "@StarberryUtils";
import { Form } from "react-bootstrap"
import { Button } from "react-bootstrap"
import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import RadioField from './elements/radio'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import { postFormData } from "./api/Api"
import $ from 'jquery/dist/jquery.min.js'
import axios from "axios"
import * as qs from "query-string"
import ContactSection from "@Components/MultiForm/ContactSection/ContactSection";
import {
  SALE_PAGE_URL,
  RENT_PAGE_URL
} from "@Components/common/site/constants";
import { getUser } from "@starberry/myaccount-website-utils"
function MySimpleForm(props) {

  const userData = getUser();

  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showthankyou, setThankyou] = useState(false);

  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();

  const fields = ([
      {
        element: "config",
        formname: "Book_Consultation",
        form_type: "Book_Consultation",
        error_text: "Highlighted fields are required",
        success_text: "Thank you for contacting us. A member of our team will contact you shortly.",
        email_temp_user: "book_consultation_user",
        email_temp_admin: "book_consultation_admin",
        email_server_func: "book_consultation",
        event_tracking: "book_consultation",
        page_url: "/general-enquiry"
      },      
      {
        grpmd: "12",
        label: "Name",
        placeholder: "Your Name*",
        name: "name",
        type: "text",
        element: "input",
        required: true,
        patternchk: "^[a-zA-Z0-9()]+(\\s+[a-zA-Z0-9()]+)*$",
        labelClass: "content_b-18",
        defaultValue: userData?.name || ``
      },
      {
        grpmd: "12",
        label: "Email",
        placeholder: "Email Address*",
        name: "email",
        type: "email",
        element: "input",
        required: true,
        patternchk:"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
        labelClass: "content_b-18",
        defaultValue: userData?.email || ``

      },
      {
        grpmd: "12",
        label: "Telephone",
        placeholder: "Telephone Number*",
        name: "telephone",
        type: "text",
        element: "input",
        required: true,
        patternchk:"^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
        labelClass: "content_b-18",
        defaultValue: userData?.mobile || ``

      },   
      {
        grpmd: "12",
        label: "Property Type",
        placeholder: "Property Type",
        name: "propertytype",
        event_tracking_decider: "type",
        element: "select",
        required: true,
        values: ['Sales', 'Lettings'],
        class: "md-12 select-input"
      },
      {
        grpmd: "12",
        label: "Additional Info",
        placeholder: "Need to share anything else? Write it here...",
        name: "message",
        element: "textarea",
        class: "mb-4",
        rows:"1",
        labelClass: "content_b-18"
      },   
      {
        grpmd: "12",
        name: "Submit Information",
        type:"submit",
        element: "button",
        value: "submit",
        class: "btn btn-success",
        labelClass: "content_b-18"
      },
      {
        text: 'By clicking Send message, you agree to our <a href="/terms-and-conditions/">Terms & Conditions</a> and <a href="/privacy-policy/">Privacy Policy</a>',
        element: "html",
        class: "form-text terms modalterms"
      },
      {
        element: "captcha",
        class: "py-2",
        captchaRef: recaptchaRef
      },
    ]);

  const handlechange = event => {
    // remove initial empty spaces
    event.target.value = event.target.value.trimStart()
  }
  useEffect(() => {
  sessionStorage.setItem('propertytype', 'Sales')
}, []);

  const url = typeof window !== 'undefined' ? window.location.href : '';
  console.log("url=>", (url.indexOf("book-a-video") > -1), url)
  if(url.indexOf("book-a-video") > -1) {
    fields[0].formname = 'Book a video';
    fields[0].event_tracking = 'book_a_video';
    fields[0].formId = 'book_a_video';
    fields[0].formLabel = 'book_a_video';
    fields[0].form_type = 'book_a_video';
  }

  useEffect(() => {
    if (token !== '') {

 const processFromData = async () => {

      let formData = new FormData();

      formData.append('data', JSON.stringify(formvalues));

      postFormData(formData).then(apiRes => {

      // lets send mail
      const axiosOptions_email = {
        url: '/.netlify/functions/server/'+fields[0].email_server_func,
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: qs.stringify(formvalues),
      }

      axios(axiosOptions_email)
        .then(response => {
          sessionStorage.removeItem("name")
          sessionStorage.removeItem("email")
          sessionStorage.removeItem("telephone")
          sessionStorage.removeItem("message")
          sessionStorage.removeItem("propertytype")
          
        })
        .catch(err =>{

        }
        );
      });

      formvalues['g-recaptcha-response'] = token;

      // const axiosOptions_netlify = {
      //   url: fields[0].page_url,
      //   method: "post",
      //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
      //   data: qs.stringify(formvalues),
      // }

      // axios(axiosOptions_netlify)
      //   .then(response => {
      //     // console.log('data stored')
      //   })
      //   .catch(err =>
      //     // console.log(err)
      //   );
      if (url.indexOf("property") > -1 && fields[4].event_tracking_decider) {
        fields[0].formname = 'Get mortgage help';
      }
      // tracking event
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'formSubmit',
        'formType': 'form-'+fields[0].event_tracking+'-'+sessionStorage.getItem('propertytype'),
        'formId': 'form-'+fields[0].event_tracking+'-'+sessionStorage.getItem('propertytype'),
        'formName': fields[0].formname+' '+sessionStorage.getItem('propertytype'),
        'formLabel': fields[0].formname+' '+sessionStorage.getItem('propertytype')
      });

      setShowerror(false);
      setThankyou(true);
      // myRef.current.scrollIntoView({ behavior: 'smooth' })

      }
      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    // console.log("captcha verified");
    setToken(token);
  };

  const handleSubmit = event => {

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      // myRef.current.scrollIntoView({ behavior: 'smooth' })
    }
    else {

      event.preventDefault();

      const formsdata = (event.target);
      const json = {}
      Object.keys(formsdata).map(key => (
        json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
      ))

      json['email_temp_user'] = fields[0].email_temp_user;
      json['email_temp_admin'] = fields[0].email_temp_admin;
      json['formname'] = fields[0].formname;
      json['g-recaptcha-response'] = token;
      // json['to_email_id'] = sessionStorage.getItem('propertytype') === "Sales" ? process.env.BOOK_SALES_MAIL_TO : sessionStorage.getItem('propertytype') === "Lettings" ? process.env.BOOK_RENT_MAIL_TO : null
      json['name'] = sessionStorage.getItem('name');
      json['email'] = sessionStorage.getItem('email');
      json['telephone'] = sessionStorage.getItem('telephone');
      json['message'] = sessionStorage.getItem('message');
      json['propertytype'] = sessionStorage.getItem('propertytype');
      json['type'] = props.Type;
      setFormvalues(json);

      recaptchaRef.current.execute();

      setValidated(false);

      // reset form
      const form = event.target
      form.reset();
      props.next()
      props.setgobackPage(true)
      
    }
  };

  return (
    <div className="form stbform">
<div ref={myRef} id="scroll_view" />
    {showerror && <div className="alert-error">
      <p>{fields[0].error_text}</p>
    </div>}

    {showthankyou && 
    // <ContactSection bookconsult={true}/>
    <>
    <h3 style={{textAlign: 'left', lineHeight: 'normal', fontSize: '30px'}}>All done. We’ll be in touch to confirm your booking.</h3>
    <div className="btn-group-block btn-bg-dark flex-btn-bk">
            <Link to={SALE_PAGE_URL.alias} className={"btn btn-primary-bg"} >Property For Sale</Link>

            <Link to={RENT_PAGE_URL.alias} className={"btn btn-outline-bg"} >Property To Rent</Link>

</div>
    {/* // <div className="alert-success">
    //   <p>{fields[0].success_text}</p>
    // </div> */}
    </>
    }
      <Form className="contact-form" name={fields[0].formname} method="post" noValidate validated={validated} onSubmit={handleSubmit}>
        <input type="hidden" name="form_name" value={fields[0].formname} />
        <input type="hidden" name="form_type" value={fields[0].form_type} />
        <input type="hidden" name="to_email_id" value={props.propertytype === "Sales" ? process.env.BOOK_SALES_MAIL_TO : props.propertytype === "Lettings" ? process.env.BOOK_RENT_MAIL_TO : null} />
        <input type="hidden" name="bot-field" />
        {fields.map((field, index) => {
            if ( "input" === field.element ) {
              return (
                <>
                {props.step === 0 && field.name === 'name' ?
                <>
                <p>Thank you for reaching out. Let’s start with your name please.</p>
                <InputField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={props.nameError ? "error-border " + field.class : field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  value={props.name}
                  handlechange={props.handlechange}
                  // label={field.label}
                  defaultValue={field?.defaultValue}
                />
                {props.nameError &&
                            <div className="error relative">
                              Please Enter name.
                            </div>
                          }
                </>
                : props.step === 1 && field.name === 'email' ?
                <>
                <p>Thanks {sessionStorage.getItem('name')}. Now we’ll need your contact details.</p>
                <InputField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={props.emailError ? "error-border " + field.class : props.valemailError && !props.emailError ? "error-border " + field.class : field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  handlechange={props.handlechange}
                  value={props.email}
                  // label={field.label}
                  defaultValue={field?.defaultValue}
                />
                {props.emailError &&
                              <div className="error relative">
                                Please Enter Email.
                              </div>
                            }
                            {props.valemailError && !props.emailError &&
                              <div className="error relative">
                                Please Enter Valid Email.
                              </div>
                            }
                </>
                
                : props.step === 1 && field.name === 'telephone' ?
                <>
                <InputField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={props.phoneError ? "error-border " + field.class : props.valphoneError && !props.phoneError ? "error-border " + field.class : field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  handlechange={props.handlechange}
                  value={props.phone}
                  // label={field.label}
                  defaultValue={field?.defaultValue}
                />
                {props.phoneError &&
                              <div className="error relative">
                                Please Enter Telephone.
                              </div>
                            }
                            {props.valphoneError && !props.phoneError &&
                              <div className="error relative">
                                Please Enter Valid Telephone.
                              </div>
                            }
                </>
                : null}

                        
                </>
              );
            }
            if ("select" === field.element) {
              return (
                props.step === 2 ?
                <>
                <p>Now we need your property information.</p>
                <SelectField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  required={field.required}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  values={field.values}
                  key={`${field.element}~${index}`}
                  handlechange={props.handlechange}
                  componentprops={props}
                  label={field.label}
                />
                </> : null
              );
            }
            if ("textarea" === field.element) {
              return (
                props.step === 2 && field.name === 'message' ?
                <TextAreaField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  rows={field.rows}
                  fieldClass={field.class}
                  labelClass={field.labelClass}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  handlechange={props.handlechange}
                  value={props.message}
                  // label={field.label}
                />: null
              );
            }
            if ("checkbox" === field.element) {
              return (
                <CheckboxField
                  name={field.name}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={props.handlechange}
                />
              );
            }
            if ("radio" === field.element) {
              return (
                <RadioField
                  name={field.name}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  checked={field.checked}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={props.handlechange}
                  lastchild={field.lastchild}
                />
              );
            }
            if ("html" === field.element) {
              return (
                props.step === 2 ?
                <HtmlBox
                  text={field.text}
                  fieldClass={field.class}
                  key={`${field.element}~${index}`}
                />
                : null
              );
            }
            if ("captcha" === field.element) {
              return (
                <ReCaptchaBox
                  fieldClass={field.class}
                  captRef={field.captchaRef}
                  key={`${field.element}~${index}`}
                  handleonVerify={handleonVerify}
                />
              );
            }
            if ("button" === field.element) {
              return (
                props.step === 2 ?
                <ButtonField
                  name={field.name}
                  fieldClass={field.class}
                  type={field.type}
                  value={field.value}
                  key={`${field.element}~${index}`}
                />
                :
                props.step === 3 ? null
                : <div className={`btns form-group`}><Button onClick={props.next}  variant="" type={'button'} className={'btn btn-success btn btn-primary'}>
                Next
                </Button>
                </div>
              );
            }
          })
        }
            

      </Form>
    </div>
  );
}


const MySimpleFormPage = (props) => (
  <MySimpleForm to_email_id={props.to_email_id} 
  phone={props.phone}
  email={props.email}
  handlechange={props.handlechange}
  valphoneError={props.valphoneError}
  valemailError={props.valemailError}
  phoneError={props.phoneError}
  emailError={props.emailError}
  nameError={props.nameError}
   name={props.name}
    setgobackPage={props.setgobackPage}
     next={props.next}
      step={props.step}
       Office={props.Office}
       message={props.message}
       propertytype={props.propertytype}
       Type={props.Type}
        />
)

export default MySimpleFormPage